<template>
    <div class="new-list-group-item">

        <div class="row g-3">
            <div class="col-5">
                <div class="tooltip-target">{{ contract.subscription.name }}<br>Publikt namn: {{ contract.subscription.name_public }}
                    <div class="tooltip-label tooltip-label-lg">
                        <h4><b>Om abonnemanget</b></h4>
                        <span>
                            <b>Typ:</b> {{ contract.subscription.nice.name }}<br>
                        </span>
                        <span>
                            <b>Behandlingslängd:</b> {{ contract.subscription.duration.minutes }} min<br>
                        </span>
                        <span>
                            <b>Massage på:</b> {{ contract.subscription.nice.location }}<br>
                        </span>
                        <span v-if="contract.subscription.num_months_binding">
                            <b>Längd:</b> {{ contract.subscription.num_months_binding }} månader<br>
                        </span>
                        <span>
                            <b>Uppsägningstid:</b> {{contract.subscription.num_months_notice_period }} månader<br>
                        </span>
                        <span v-if="contract.subscription.num_months_settlement_interval">
                            <b>Avräkningsperiod:</b> {{ contract.subscription.num_months_settlement_interval }} månader<br>
                        </span>
                        <span v-if="contract.subscription.num_treatments">
                            <b>Max antal behandlingar:</b> {{ contract.subscription.num_treatments }} st<br>
                        </span>
                        <span>
                            <b>Uppsägning</b> {{ contract.subscription.nice.notice_info }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-2">
                <span>{{ contract.starts_at }}</span>
            </div>
            <div class="col-2">
                <span v-if="contract.start_fee">{{ contract.start_fee }} kr</span>
            </div>
            <div class="col-2">
                <span v-if="!contract.ends_at">Aktivt</span>
                <span v-if="contract.ends_at && !dateIsAfterNow(contract.ends_at)">Uppsagt</span>
                <span v-if="contract.ends_at && dateIsAfterNow(contract.ends_at)">Avslutat</span>
            </div>
            <div class="col-3">
                <span>{{ contract.admin.name }}</span>
            </div>
            <div class="col-2">
                <span>
                    <a :href="'/companies/' + contract.company_id + '/contracts/' + contract.id+'/downloadTemplate'"
                       target="_blank">
                        <span class="fa fa-arrow-down" style="margin-right: 4px;"></span>Hämta
                    </a>
                </span>
            </div>
            <div class="col-3">
                <span>
                    <a :href="'/companies/' + contract.company_id + '/contracts/' + contract.id+'/downloadReal'"
                       target="_blank">
                        <span class="fa fa-check" style="margin-right: 4px;"></span>Uppladdat
                    </a>
                </span>
            </div>
            <div class="col-2">
                <span v-if="contract.subscription.type === 'binding_period' && contract.next_renewal_at">{{ contract.next_renewal_at }}</span>
            </div>
            <div class="col-3">
                <div class="row g-1" v-if="dateIsAfterNow(contract.ends_at) || pendingContract(contracts)">
                    {{ contract.ends_at }}
                </div>

                <div class="row g-1" v-if="canChangeEndsAt">
                    <div class="col-24">
                        <datepicker-new
                            input-class="form-control form-control-sm"
                            placeholder="Välj"
                            :use-utc="false"
                            :language="former.datepicker.locale"
                            :monday-first="true"
                            :disabled-dates="disabledDatesEndsAt"
                            :format="formerDateFormat"
                            v-model="ends_at"
                        />
                    </div>
                    <div class="col-24">
                        <button class="btn btn-primary btn-sm w-100" :disabled="patcher.submitted" @click="patcherPatch()" v-if="!contract.ends_at">
                            Säg upp <div class="tooltip-label">Detta går att ångra.</div>
                        </button>
                        <button class="btn btn-info btn-sm w-100" :disabled="patcher.submitted" @click="patcherPatch()" v-if="contract.ends_at">
                            Ändra datum <div class="tooltip-label">Ange först ett nytt uppsägningsdatum i rutan och spara det nya datumet med knappen.</div>
                        </button>
                        <button class="btn btn-warning btn-sm w-100 mt-1" @click="abortEndsAt()" v-if="contract.ends_at && !pendingContract(contracts)">
                            Ångra uppsägning <div class="tooltip-label">Du kan ånga en uppsägning fram till att du påbörjat ett nytt avtal eller att uppsägningsdatumet passerat.</div>
                        </button>
                    </div>
                </div>
                <div class="row" v-if="dateIsAfterNow(contract.ends_at)">
                    <div class="col">
                        Uppsägningsdatumet har passerat.
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

import patcher from '../../../../shared/mixins/patcher'
import { activeContract, pendingContract } from '../../../../shared/methods/contract-filter'

export default {

    mixins: [
        patcher
    ],

    props: {
        contract: {
            required: true
        },
        contracts: {
            required: true
        }
    },

    data () {
        return {
            ends_at: this.contract.ends_at,

            datepicker: {
                disabledDatesEndsAt: {
                    customPredictor (date) {
                        if (date.getDate() !== 1 && date.getDate() !== 15) {
                            return true
                        }
                    }
                }
            }
        }
    },

    computed: {
        canChangeEndsAt () {
            if (this.dateIsAfterNow(this.contract.ends_at)) {
                return false
            }
            if (this.pendingContract(this.contracts) && this.pendingContract(this.contracts).id !== this.contract.id) {
                return false
            }
            if (this.contracts.find(c => moment(c.starts_at).isAfter(moment(this.contract.starts_at)))) {
                return false
            }

            return true
        },
        disabledDatesEndsAt () {
            const self = this

            return {
                customPredictor (date) {
                    if (moment(date).isBefore(moment(self.contract.starts_at))) {
                        return true
                    }
                    if (moment(date).isSameOrBefore(moment())) {
                        return true
                    }

                    const starts_at_day = moment(self.contract.starts_at).date()
                    if (starts_at_day === 1 && date.getDate() !== moment(date).endOf('month').date()) {
                        return true
                    }
                    if (starts_at_day === 15 && date.getDate() !== 14) {
                        return true
                    }
                }
            }
        },
        patcherUrl () {
            return '/companies/' + this.contract.company_id + '/contracts/' + this.contract.id
        },
        patcherData () {
            return { ends_at: this.ends_at }
        }
    },

    methods: {
        dateIsAfterNow (date) {
            return moment().isAfter(date)
        },

        abortEndsAt () {
            this.ends_at = null
            this.patcherPatch()
        },

        patcherSuccess () {
            if (!this.ends_at) {
                bus.$emit(
                    'notify',
                    'Uppsägningen har ångrats'
                )
            } else {
                bus.$emit(
                    'notify',
                    'Abonnemanget har sagts upp'
                )
            }

            this.$emit('refresh')
        },

        pendingContract: pendingContract
    }

}
</script>
